export * as CancelOrderV2 from './CancelOrderV2.generated';
